import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import config from '../../../config';
import {MailTemplate} from "../../../classes/mailTemplate";

@Injectable()
export class kanMailTemplatesService {
    constructor(private http: HttpClient) {
    }

    public getTemplates(): Promise<MailTemplate[]> {
        return new Promise((resolve, reject) => {
            this.http.get(`${config.apiRootUrl}/api/mailTemplates`)
                .toPromise()
                .then((response: any) => {

                    resolve(response as MailTemplate[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public addTemplate(template: MailTemplate): Promise<MailTemplate> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/mailTemplates`, template)
                .toPromise()
                .then((response: any) => {
                    resolve(response as MailTemplate);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public updateTemplate(template: MailTemplate): Promise<MailTemplate> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/mailTemplates/${template.id}`, template)
                .toPromise()
                .then((response: any) => {
                    resolve(response as MailTemplate);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public removeTemplate(template: MailTemplate): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/mails/${template.id}`, {})
                .toPromise()
                .then((response: any) => {
                    resolve(true);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/templates.ts